/**
 * Firebase Configuration
 *
 * ⚠️ THIS FILE IS GIT-IGNORED - Add your real Firebase credentials here
 *
 * To set up Firebase:
 * 1. Go to https://console.firebase.google.com/
 * 2. Create a new project or select existing
 * 3. Add a Web App and copy the config
 * 4. Replace the config below with your values
 * 5. Enable Authentication and Firestore in Firebase Console
 */

import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getFunctions, Functions } from 'firebase/functions';
import { getAnalytics, Analytics } from 'firebase/analytics';
import { Logger } from '../utils/Logger';

const logger = Logger.getLogger('FirebaseConfig');

// TODO: Replace with your actual Firebase configuration
// Get this from Firebase Console > Project Settings > Your apps > Config
const firebaseConfig = {
  apiKey: "AIzaSyC8fBDeIOH19O27vGcjqTu5WQcMpkzrIA8",
  authDomain: "webxrgallery.firebaseapp.com",
  projectId: "webxrgallery",
  storageBucket: "webxrgallery.firebasestorage.app",
  messagingSenderId: "517880920535",
  appId: "1:517880920535:web:5a4bbe3e8d33075a0f3392",
  measurementId: "G-7QKB4JCYEH"
};
// Initialize Firebase
let app: FirebaseApp;
let auth: Auth;
let db: Firestore;
let storage: FirebaseStorage;
let functions: Functions;
let analytics: Analytics | null = null;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  functions = getFunctions(app);

  // Initialize Analytics (only in browser environment)
  if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
    analytics = getAnalytics(app);
    logger.info('Firebase Analytics initialized');
  }

  logger.info('Firebase initialized successfully');
} catch (error) {
  logger.error('Firebase initialization failed:', error);
  logger.error('Please add your Firebase config to src/firebase/config.ts');
  throw error;
}

export { auth, db, storage, functions, analytics };
export default app;
